import type { ReactNode } from "react";
import {
  HomeNotificationIcon,
  type HomeNotificationKind,
} from "./HomeNotificationIcon";
import { historyDate } from "../order/deliveryHistory/deliveryHistoryDates";

type MessageProps = {
  kind: HomeNotificationKind;
  orderReference: ReactNode;
  supplierName: string;
  deliveryDate?: Date | null;
};

function HomeNotificationMessage({
  kind,
  orderReference,
  supplierName,
  deliveryDate,
}: MessageProps) {
  const orderWithSupplier = (
    <>
      {orderReference} with {supplierName}
    </>
  );
  switch (kind) {
    case "cardFailed":
      return <>Card payment for {orderWithSupplier} failed to process</>;
    case "creditFailed":
      return (
        <>We were unable to add {orderWithSupplier} to your Sellar Credit tab</>
      );
    case "addToTab":
      return <>Add {orderWithSupplier} to your Sellar Credit tab</>;
    case "deliveryDelayed":
      return (
        <>
          Your expected delivery date for {orderWithSupplier} has been delayed
          {deliveryDate
            ? ` to ${historyDate(deliveryDate)}`
            : ". We’ll confirm the updated delivery date."}
        </>
      );
    case "actionRequired":
      return <>Action required for {orderWithSupplier}</>;
  }
}

export function HomeNotificationCard({
  actions,
  ...message
}: MessageProps & { actions: ReactNode }) {
  return (
    <div className="flex items-start gap-3 text-sm">
      <HomeNotificationIcon kind={message.kind} />
      <div className="flex min-w-0 flex-1 flex-col gap-3">
        <p className="leading-7">
          <HomeNotificationMessage {...message} />
        </p>
        <div className="flex flex-wrap items-center gap-3">{actions}</div>
      </div>
    </div>
  );
}
